export default "__VITE_ASSET__1b425fb9__"